import cx from "classnames";
import {
  SponsorshipBox,
  useCustomClassContext,
  UserSubmissionBox,
} from "../../../main";
import React, { ReactElement, ReactNode } from "react";
import { SectionSubHeading } from "../../Block/SectionHeading/SectionHeading";
import * as Typography from "../../Element/Typography";
import styles from "./contentblock.module.css";

const { Heading, TextLink } = Typography;

type ContentBlockProps = {
  heading: string;
  headingZH?: string;
  children?: ReactNode;
  arrows?: ReactNode;
  inlineGutter?: boolean;
  cta?: {
    name?: string;
    url: string;
    icon?: ReactNode;
    headingIcon?: ReactNode;
  };
  isHeadingClickable?: boolean;
  imu?: ReactNode;
  withDivider?: boolean;
  description?: string;
  userSubmissionBox?: UserSubmissionBox;
};

const ContentBlock: React.FC<ContentBlockProps> = ({
  heading,
  headingZH,
  arrows,
  inlineGutter = false,
  cta,
  children,
  isHeadingClickable = false,
  imu,
  withDivider = true,
  description,
  userSubmissionBox,
}): ReactElement => {
  const customClass = useCustomClassContext();

  return (
    <div className={styles.contentBlockContainer}>
      {heading && (
        <div
          className={cx(
            styles.contentBlockContainerHeading,
            inlineGutter && styles.mDownGutterSides,
          )}
        >
          {headingZH ? (
            <Heading.SubSectionTitle
              nameZH={headingZH}
              headingUrl={(isHeadingClickable && cta && cta.url) || ""}
            >
              {heading}
            </Heading.SubSectionTitle>
          ) : (
            <SectionSubHeading
              title={heading}
              arrows={arrows}
              headingUrl={(isHeadingClickable && cta && cta.url) || ""}
              withDivider={withDivider}
              description={description}
            />
          )}
          {cta?.headingIcon}
        </div>
      )}

      <div className={cx(imu && styles.innerContainer)}>
        <div>
          {children}
          {cta?.name && (
            <div
              className={cx(
                styles.ctaContainer,
                customClass?.contentBlock?.cta,
              )}
            >
              <TextLink href={cta.url}>
                {cta.name}
                {cta.icon}
              </TextLink>
            </div>
          )}
          {userSubmissionBox && (
            <div className={styles.userSubmission}>
              <SponsorshipBox
                inPage={true}
                {...userSubmissionBox}
                buttonType="primary"
              />
            </div>
          )}
        </div>
        {imu && <div className={styles.imuContainer}>{imu}</div>}
      </div>
    </div>
  );
};

export default ContentBlock;
